import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import BrokerWalletsTable from "../../components/Wallets/BrokerWalletsTable";

const BrokerWalletsPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Broker Wallets" />
      <BrokerWalletsTable />
    </MasterLayout>
  );
};

export default BrokerWalletsPage;
